import { ArrowRight } from "lucide-react";
import React, { useState } from "react";
import AlphaWhyManagedModal from "./AlphaWhyManagedModal";

export interface AlphaWhyManagedTeaserProps {
  productId?: number | null;
  selfDirected?: boolean;
  showAdopt?: boolean;
  onAdopt?: (managedProductId: number) => void;
  mode?: "interactive" | "static";
}

const AlphaWhyManagedTeaser: React.FC<AlphaWhyManagedTeaserProps> = ({
  selfDirected = false,
  showAdopt = false,
  onAdopt,
  mode = "interactive",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const heading = selfDirected
    ? "You could be doing more with Plutus Managed"
    : "Why Plutus Managed?";
  const subtitle = selfDirected
    ? "An allocation engine designed by the Plutus team to meet your needs."
    : "Matched to your risk, diversified, and rebalanced for you.";

  const body = (
    <>
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-v7-control bg-v7-ink font-v7-serif text-lg italic text-v7-white">
        P
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-v7-ink">{heading}</span>
        <span className="mt-0.5 block text-[13px] text-v7-ink-soft">
          {subtitle}
        </span>
      </span>
    </>
  );

  if (mode === "static") {
    return (
      <div
        data-testid="alpha-why-managed-teaser"
        className="mt-6 flex w-full items-center gap-3.5 rounded-v7-panel border border-v7-bronze-dark/30 bg-v7-paper px-4 py-3.5 text-left"
      >
        {body}
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        data-testid="alpha-why-managed-teaser"
        onClick={() => setIsModalOpen(true)}
        className="mt-6 flex w-full items-center gap-3.5 rounded-v7-panel border border-v7-bronze-dark/30 bg-v7-paper px-4 py-3.5 text-left transition-colors hover:border-v7-bronze-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-v7-bronze-dark"
      >
        {body}
        <span className="inline-flex shrink-0 items-center gap-1.5 text-[13px] font-semibold text-v7-bronze-dark">
          Learn more
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </span>
      </button>

      <AlphaWhyManagedModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        showAdopt={showAdopt}
        onAdopt={onAdopt}
      />
    </>
  );
};

export default AlphaWhyManagedTeaser;
